import React from "react";
import useSeoDefault from "../../utils/useSeoDefault";
import useSiteMetadata from "../../utils/useSiteMetadata";
import undefinedIfEmpty from "../../utils/undefinedIfEmpty";

interface SeoBaseInterface {
   title?: string,
   description?: string,
   keywords?: string,
   robots?: string
}

interface SeoInterface extends SeoBaseInterface {
   image?: string,
   url?: string,
   schemamk?: string
}

export interface SeoContainerInterface extends SeoBaseInterface {
   image?: {
      url?: string
   }
   path?: string,
   schemamk?: object
}

export const SEO = ({ title, description, url, image, keywords, robots, schemamk } : SeoInterface) => {
   let twitter, og;
   if (title && description && image && url) {
      twitter = 
         <>
            <meta name="twitter:card" content="summary" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={image} />
            <meta name="twitter:url" content={url} />
         </>;

      og = 
         <>
            <meta name="og:title" content={title} />
            <meta name="og:description" content={description} />
            <meta name="og:image" content={image} />
            <meta name="og:url" content={url} />
         </>;
   }

   return (
      <>
         <title>{title}</title>
         { description && <meta name="description" content={description} /> }
         { image && <meta name="image" content={image} /> }
         { keywords && <meta name="keywords" content={keywords} /> }
         { robots && <meta name="robots" content={robots} /> }
         { 
            schemamk && 
            <script type="application/ld+json">
               { schemamk }
            </script>
         }
         { og }
         { twitter }
      </>
   )
}

const SEOContainer = ({ title, description, path, image, keywords, robots, schemamk } : SeoContainerInterface) => {
   const defaultSeo = useSeoDefault()
   const site = useSiteMetadata();

   const seo = {
      title: title || defaultSeo.title || site.title,
      description: description || defaultSeo.description,
      image: image?.url || defaultSeo.image?.url,
      url: `${site.siteUrl}${path || ''}`,
      keywords: keywords || defaultSeo.keywords,
      robots: robots || defaultSeo.robots,
      schemamk: JSON.stringify(undefinedIfEmpty(schemamk) || undefinedIfEmpty(defaultSeo.schemamk))
   }

   return <SEO {...seo} />;
}

export default SEOContainer;
